import './containertitle.less'

import {action, classes, Component} from '@codeurs/front'
import m from 'mithril'
import {t} from 'store'
import Link from './link'

export default class ContainerTitle extends Component<{
	className?: string
	text: string
	mod?: string
}> {
	view() {
		const {className, text, mod} = this.attrs

		return m('.containertitle', {...classes({mod}, className)}, [
			m('.containertitle-text', text),
			this.getLine(mod)
		])
	}
	getLine(mod: string) {
		if (!mod) return m('.containertitle-line')
		if (mod == 'articledetail' || mod == 'pulicationdetail') {
			return m(Link,
				{mod: 'blue', class: 'containertitle-link', ...action('/news')},
				t('articles.showmore') + ' >'
			)
		}
		return
	}
}
